import { memo } from 'react'
import { useTranslations } from '@/core/translation'
import { InfoCircleIcon } from '@/assets'
import { Box } from '../../Layout'
import { Button } from '../../Inputs'
import Modal from '../Modal'
import { confirmationModalStyles as styles } from './ConfirmationModal.style'
import { ConfirmationModalProps } from './ConfirmationModal.types'

function ConfirmationModal({
  children,
  onCancelClick,
  onConfirmClick,
  hideCancel = false,
  cancelButtonText,
  confirmButtonText,
  loading,
  ...props
}: ConfirmationModalProps) {
  const t = useTranslations('components')

  return (
    <Modal
      HeaderIcon={
        <Box sx={styles.headerIconWrapper}>
          <Box sx={styles.headerIcon} component={InfoCircleIcon} />
        </Box>
      }
      containerStyles={styles.container}
      {...props}>
      <>
        {children}
        <Box sx={styles.actions.wrapper}>
          {!hideCancel && (
            <Button
              variant="outlined"
              color="secondary"
              size="small"
              fullWidth
              sx={styles.actions.cancelButton}
              onClick={onCancelClick}>
              {cancelButtonText ?? t('confirmationModal.cancel')}
            </Button>
          )}
          <Button
            variant="contained"
            color="primary"
            size="small"
            fullWidth
            loading={loading}
            sx={styles.actions.confirmButton}
            onClick={onConfirmClick}>
            {confirmButtonText ?? t('confirmationModal.confirm')}
          </Button>
        </Box>
      </>
    </Modal>
  )
}

export default memo(ConfirmationModal)
